"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var extrasHelpers = _interopRequireWildcard(require("../helpers/extras"));
var _constants = require("../constants");
var _envConstants = require("./../env-constants");
var _ExtrasFlightPicker = _interopRequireDefault(require("./ExtrasFlightPicker"));
var _ExtrasTransferBreakdown = _interopRequireDefault(require("./ExtrasTransferBreakdown"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ExtrasTransferProduct = /*#__PURE__*/function (_Component) {
  function ExtrasTransferProduct(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ExtrasTransferProduct);
    _this = _callSuper(this, ExtrasTransferProduct, [props]);
    (0, _defineProperty2["default"])(_this, "setExistingTransferToState", function (crewMember) {
      if (crewMember && crewMember.okTransfers && crewMember.okTransfers.length) {
        var arrivalTransfer = crewMember.okTransfers.find(function (transfer) {
          return transfer.type === _constants.EXTRAS.ARRIVAL;
        });
        var departureTransfer = crewMember.okTransfers.find(function (transfer) {
          return transfer.type === _constants.EXTRAS.DEPARTURE;
        });
        var arrival = {};
        var departure = {};
        if (arrivalTransfer) {
          var variant = (0, _toConsumableArray2["default"])(_this.props.product.productVariants).find(function (variant) {
            return variant.id === arrivalTransfer.orderItem.productVariant.id;
          });
          arrival = {
            flight: {
              value: null,
              label: arrivalTransfer.flightNr
            },
            airport: {
              value: null,
              label: arrivalTransfer.pickUpDropOff
            },
            variant: {
              value: variant,
              label: variant.name
            }
          };
        }
        if (departureTransfer) {
          var _variant = (0, _toConsumableArray2["default"])(_this.props.product.productVariants).find(function (variant) {
            return variant.id === departureTransfer.orderItem.productVariant.id;
          });
          departure = {
            flight: {
              value: null,
              label: departureTransfer.flightNr
            },
            airport: {
              value: null,
              label: departureTransfer.pickUpDropOff
            },
            variant: {
              value: _variant,
              label: _variant.name
            }
          };
        }
        _this.setState({
          arrival: arrival,
          departure: departure,
          disabled: true
        });
      }
    });
    (0, _defineProperty2["default"])(_this, "updateDepartureFlights", function () {
      var product = _this.props.product;
      var airport = _this.state.departure.airport && _this.state.departure.airport.label;
      var departureFlightAirports = product.product.departureFlightAirports;
      var departureFlightArray = departureFlightAirports[airport] || [];
      var departureFlights = departureFlightArray.map(function (flight) {
        return {
          value: flight,
          label: flight.flightNr
        };
      }).sort(function (a, b) {
        return a.label > b.label ? 1 : -1;
      });
      _this.setState({
        departureFlights: departureFlights
      });
    });
    (0, _defineProperty2["default"])(_this, "updateArrivalFlights", function () {
      var product = _this.props.product;
      var airport = _this.state.arrival.airport && _this.state.arrival.airport.label;
      var arrivalFlightAirports = product.product.arrivalFlightAirports;
      var arrivalFlightArray = arrivalFlightAirports[airport] || [];
      var arrivalFlights = arrivalFlightArray.map(function (flight) {
        return {
          value: flight,
          label: flight.flightNr
        };
      });
      _this.setState({
        arrivalFlights: arrivalFlights
      });
    });
    (0, _defineProperty2["default"])(_this, "updateFlights", function () {
      _this.updateArrivalFlights();
      _this.updateDepartureFlights();
    });
    (0, _defineProperty2["default"])(_this, "updateFlight", function (flight, direction) {
      _this.updateSelectedProperty('flight', flight, direction);
    });
    (0, _defineProperty2["default"])(_this, "updateVariant", function (variant, direction) {
      _this.updateSelectedProperty('variant', variant, direction);
    });
    (0, _defineProperty2["default"])(_this, "updateAirport", function (airport, direction) {
      _this.updateSelectedProperty('airport', airport, direction);
    });
    _this.state = {
      ordering: false,
      orderingVariant: null,
      variant: null,
      arrival: {},
      departure: {},
      arrivalFlights: [],
      departureFlights: []
    };
    _this.canOrder = _this.canOrder.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ExtrasTransferProduct, _Component);
  return (0, _createClass2["default"])(ExtrasTransferProduct, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setExistingTransferToState(this.props.crewMember);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.crewMember || prevProps.crewMember && prevProps.crewMember.okTransfers.length !== this.props.crewMember.okTransfers.length) {
        this.setExistingTransferToState(this.props.crewMember);
      }
    }
  }, {
    key: "updateSelectedProperty",
    value: function updateSelectedProperty(propertyName, property, direction) {
      var _this2 = this;
      this.setState(function (prevState) {
        return (0, _defineProperty2["default"])({}, direction, _objectSpread(_objectSpread({}, prevState[direction]), {}, (0, _defineProperty2["default"])({}, propertyName, property)));
      }, function () {
        _this2.updateFlights();
      });
    }
  }, {
    key: "canOrder",
    value: function canOrder() {
      var product = this.props.product;
      var flightSelected = this.state.arrival.flight || this.state.departure.flight;
      var hasTransfersAlready = this.props.crewMember && this.props.crewMember.okTransfers.length;
      return !!this.props.crewMember && !!product.product.available && !!flightSelected && !hasTransfersAlready;
    }
  }, {
    key: "renderInfo",
    value: function renderInfo(variant) {
      var product = this.props.product.product;
      var text = '';
      if (variant && variant.ordered) {
        text = 'Added';
      } else if (product.available) {
        text = "Must be added before ".concat((0, _moment["default"])(product.availableUntil).format('Do MMM'));
      }
      return text ? /*#__PURE__*/_react["default"].createElement("strong", null, text) : false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        match = _this$props.match,
        crewMember = _this$props.crewMember;
      var productVariants = [];
      var product = null;
      var destinationAirports = [];
      if (this.props.product) {
        productVariants = this.props.product.productVariants;
        product = this.props.product.product;
        destinationAirports = product.destinationAirports;
      }
      var _this$state = this.state,
        variant = _this$state.variant,
        disabled = _this$state.disabled;
      var orderingExtra = this.state.ordering && this.state.orderingVariant === variant.value.id;
      var variantSelect = productVariants.map(function (variant) {
        return {
          value: variant,
          label: variant.name
        };
      });
      var transparent = !product.available || orderingExtra;
      var imgSrc = extrasHelpers.getDefaultImage(product.type, _constants.EXTRAS.COPY);
      var name = variant && variant.value.name;
      var airportSelect = product.destinationAirports.map(function (destAirport) {
        return {
          value: destAirport.airport.name,
          label: destAirport.airport.name
        };
      });
      var _this$state2 = this.state,
        arrival = _this$state2.arrival,
        departure = _this$state2.departure;
      var variantArray = [];
      if (arrival.flight) {
        variantArray.push({
          variant: arrival.variant.value,
          flight: arrival.flight.value,
          quantity: 1
        });
      }
      if (departure.flight) {
        variantArray.push({
          variant: departure.variant.value,
          flight: departure.flight.value,
          quantity: 1
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "transfer-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "transfer-product ".concat(transparent ? ' extras-unavailable' : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "img-card"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: "extras-image",
        src: imgSrc,
        alt: name
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "img-card-top-text",
        "data-postid": "28476"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "s-font white-text tal"
      }, this.renderInfo(variant)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mt20 mb20"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Please fill in your ", /*#__PURE__*/_react["default"].createElement("strong", null, "flight numbers"), " correctly at the point of check in. Only if you fill out the correct details at check in can we adapt to any delays or cancellations should that be the case.")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "transfer-selection"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "arrival"
      }, /*#__PURE__*/_react["default"].createElement(_ExtrasFlightPicker["default"], {
        direction: _constants.EXTRAS.ARRIVAL,
        variants: variantSelect,
        selectedVariant: arrival.variant,
        airports: airportSelect,
        selectedAirport: arrival.airport,
        flights: this.state.arrivalFlights,
        selectedFlight: arrival.flight,
        updateFlight: this.updateFlight,
        updateVariant: this.updateVariant,
        updateAirport: this.updateAirport,
        disabled: disabled,
        destinationAirports: destinationAirports
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "departure"
      }, /*#__PURE__*/_react["default"].createElement(_ExtrasFlightPicker["default"], {
        direction: _constants.EXTRAS.DEPARTURE,
        variants: variantSelect,
        selectedVariant: departure.variant,
        airports: airportSelect,
        selectedAirport: departure.airport,
        flights: this.state.departureFlights,
        selectedFlight: departure.flight,
        updateFlight: this.updateFlight,
        updateVariant: this.updateVariant,
        updateAirport: this.updateAirport,
        disabled: disabled,
        destinationAirports: destinationAirports
      }))), this.canOrder() ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "transfer-checkout-button"
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        disabled: orderingExtra,
        to: {
          pathname: "".concat(match.url, "/checkout/"),
          state: {
            page: 'checkout',
            productVariants: variantArray
          }
        },
        className: "btn btn-primary".concat(orderingExtra ? ' disabled' : ''),
        style: {
          Width: '50%'
        }
      }, "Purchase")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "extras-text",
        style: {
          margin: '25px 0',
          backgroundColor: '#eee'
        }
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "extras-title"
      }, name), this.state.arrival.flight && /*#__PURE__*/_react["default"].createElement(_ExtrasTransferBreakdown["default"], {
        variant: this.state.arrival.variant.value
      }), this.state.departure.flight && /*#__PURE__*/_react["default"].createElement(_ExtrasTransferBreakdown["default"], {
        variant: this.state.departure.variant.value
      }))) : !this.props.crewMember && /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-error",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "material-icons abs small-icon",
        style: {
          marginRight: '1rem'
        }
      }, "info"), /*#__PURE__*/_react["default"].createElement("p", null, "Only a crew member can order a transfer")), crewMember && crewMember.okTransfers && !!crewMember.okTransfers.length && /*#__PURE__*/_react["default"].createElement("h3", {
        style: {
          marginTop: '2rem'
        }
      }, "You have ordered the above transfers. To change these, contact", ' ', /*#__PURE__*/_react["default"].createElement("a", {
        href: "mailto:info@".concat(_envConstants.ENV.PROD_ROOT_DOMAIN)
      }, "customer support"))));
    }
  }]);
}(_react.Component);
ExtrasTransferProduct.propTypes = {
  product: _propTypes["default"].object.isRequired,
  match: _propTypes["default"].object.isRequired,
  crewMember: _propTypes["default"].object
};
var _default = exports["default"] = ExtrasTransferProduct;